<div class="list-page kapea" style="max-width: 1500px">
  <h2 class="header">Ajastetut työt</h2>

  <form novalidate>
    <div class="ylaosan-kontrollit" style="margin: 0; justify-content: space-between; align-items: center">
      <div class="hakukontrollit" style="align-items: baseline">
        <mat-form-field floatPlaceholder="always" style="width: 570px; margin-right: 1.5vw">
          <mat-label>Tyyppi</mat-label>
          <mat-select [formField]="lomake.tyyppi">
            <mat-option [value]="'all'">Kaikki</mat-option>
            @for (type of ajastetunTyonTyyppi; track type) {
              <mat-option [value]="type.tyyppi">
                {{ type.teksti }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-radio-group [formField]="lomake.tulossaVaiHistoria">
          <mat-radio-button [value]="'tulossa'">Tulossa</mat-radio-button>
          <mat-radio-button [value]="'historia'">Historia</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </form>

  <div style="width: 100%">
    <div style="position: relative; width: 100%">
      <mat-table mat-table multiTemplateDataRows matSort [dataSource]="dataSource" [matSortDisableClear]="true" style="min-height: 94px">
        <ng-container matColumnDef="linkki">
          <th mat-header-cell *matHeaderCellDef style="min-width: 30px">&nbsp;</th>
          <td mat-cell class="mat-mdc-cell" *matCellDef="let row" style="min-width: 30px">
            <tr>
              <td>
                <span (click)="openLink(row.asiakasAvain, $event)" class="fa fa-external-link link-btn" matTooltip="Avaa asiakkaan tiedot uudella välilehdellä"></span>
              </td>
            </tr>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="asiakasAvain">
          <th mat-header-cell *matHeaderCellDef style="min-width: 220px">Asiakas</th>
          <td mat-cell class="mat-mdc-cell" *matCellDef="let row" style="min-width: 220px">
            <tr>
              <td>{{ row.asiakasAvain || 'Ei asiakasta' }}</td>
            </tr>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="ajoaika">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 180px">Ajoaika</th>
          <td mat-cell class="mat-mdc-cell" *matCellDef="let row" style="min-width: 180px">
            <tr>
              <td>{{ (row.ajoaika.toDate() | ldatetime | async) || 'Ei saatavilla' }}</td>
            </tr>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- <ng-container matColumnDef="tyyppi">
        <th mat-header-cell *matHeaderCellDef style="min-width: 250px;"> Tyyppi </th>
        <td mat-cell class="mat-mdc-cell" *matCellDef="let row" style="min-width: 250px;">
          <tr>
            <td>{{ row.tyyppi || 'Ei saatavilla' }}</td>
          </tr>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container> -->

        <ng-container matColumnDef="selite">
          <th mat-header-cell *matHeaderCellDef style="min-width: 200px">Selite</th>
          <td mat-cell class="mat-mdc-cell" *matCellDef="let row" style="min-width: 200px">
            <tr>
              <td>{{ row.selite || 'Ei saatavilla' }}</td>
            </tr>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <mat-header-row *matHeaderRowDef="naytettavatKolumnit"></mat-header-row>
        <mat-row (click)="katsoTiedot(row)" *matRowDef="let row; columns: naytettavatKolumnit"></mat-row>
      </mat-table>

      <mat-paginator [length]="dataSource.data?.length" [pageSize]="25" [pageSizeOptions]="[20, 50, 200]"> </mat-paginator>
    </div>
  </div>
</div>
